import { fulfilled, failed, pending } from "lib/promiseMiddlewareTypes";
import initialState from "store/initialState";
import { USER_AUTH, USER_VALIDATE } from "actions/user";
import { COOKIE_JWT_ACCESS_TOKEN, COOKIE_JWT_ID_TOKEN, removeCookie } from "lib/Cookies";

const user = (state = initialState.user, action: any) => {
  switch (action.type) {
    case failed(USER_AUTH):
    case pending(USER_AUTH):
    case failed(USER_VALIDATE):
    case pending(USER_VALIDATE):
      return initialState.user;
    case USER_AUTH:
      return action.payload;
    case fulfilled(USER_VALIDATE):
      if (!action.payload.access) {
        removeCookie(COOKIE_JWT_ACCESS_TOKEN);
        removeCookie(COOKIE_JWT_ID_TOKEN);
        //return { valid: false };
      }
      return state;
    default:
      return state;
  }
};

export default user;
